import { useEffect, useMemo, useState } from "react";
import { Popover } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useNotificationPermission } from "../../hooks/useNotificationPermission";
import { useDispatch, useSelector } from "react-redux";
import {
  set_notification_popover,
  set_open_new_notification,
} from "../../store/actions/login_actions";
import { useLangNavigate } from "../../hooks/useLangNavigate";
import styles from "./Page.module.css";
import { ReactComponent as NotificationIcon } from "./../../assets/svg/notification.svg";
// import { set_open_new_notification } from '../../store/actions/popup_actions';

const PopoverContent = ({ children }) => (
  <p style={{ maxWidth: "200px" }}>{children}</p>
);

export const NotificationButton = ({ onOpenChange }) => {
  const { i18n, t } = useTranslation();
  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const Login = useSelector((state) => state.Login);
  const Notification = useSelector((state) => state.Notification);
  // const { Login.openNewNotification } = useSelector((state) => state.Popup);
  // const [qrOpen, setQrOpen] = useState(true);
  const [open, setOpen] = useState(Login.notificationPopover);
  // const [newOpen, setNewOpen] = useState(Login.openNewNotification);

  const { permission } = useNotificationPermission();

  const unseenNotif = useMemo(() => {
    if (Notification.length > 0 && Login.is_login) {
      return Notification.filter((item) => !item.seen && !item.is_expired);
    }
    return [];
  }, [JSON.stringify(Notification)]);

  useEffect(() => {
    if (!Object.prototype.hasOwnProperty.call(Login, "notificationPopover")) {
      dispatch(set_notification_popover(true));
    } else {
      setOpen(Login.notificationPopover);
    }
  }, [Login]);

  useEffect(() => {
    if (!Object.prototype.hasOwnProperty.call(Login, "notificationPopover")) {
      dispatch(set_open_new_notification(true));
    }
  }, [Login.openNewNotification]);

  let popoverContent;
  let popoverOpen;
  let popoverOnOpenChange;

  if (unseenNotif.length > 0) {
    popoverOpen = Login.openNewNotification;
    popoverOnOpenChange = () =>
      dispatch(set_open_new_notification(!Login.openNewNotification));

    const firstNotif = unseenNotif[0];
    let contentKey;

    switch (true) {
      case firstNotif?.metadata?.type === "qr_code":
        contentKey = "notifications.popover.qr";
        break;

      case firstNotif.type === "ORDER":
        contentKey = "notifications.popover.order";
        break;

      case firstNotif.type === "ALERT":
        contentKey = "notifications.popover.general";
        break;

      case firstNotif.type === "OTP":
        contentKey = "notifications.popover.otp";
        break;

      default:
        contentKey = null;
    }

    if (contentKey) {
      popoverContent = (
        <PopoverContent>
          <span
            className={styles.popoverLink}
            onClick={() => navigate("/notifications")}
          >
            {t(contentKey)}
          </span>
        </PopoverContent>
      );
    } else {
      popoverContent = null;
    }
  } else {
    const contentKey =
      permission === "granted"
        ? "notifications.popover.enable"
        : "notifications.popover.disable";
    popoverContent = (
      <PopoverContent>
        <span onClick={() => navigate("/notifications")}>{t(contentKey)}</span>
      </PopoverContent>
    );
    popoverOpen = Login.channel === "promotion-channel" ? open : false;
    popoverOnOpenChange = setOpen;
  }
  if (Login.channel === "canada") {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (onOpenChange) {
      onOpenChange(popoverOpen);
    }
  }, [popoverOpen, onOpenChange]);

  const isLTR = i18n.dir() === "ltr";
  const popoverPlacement = isLTR ? "bottomRight" : "bottomLeft";
  const popoverAlignOffset = isLTR ? [9.5, 8] : [-9.5, 8];

  const iconContainerClasses = clsx(styles.IconContainer, {
    [styles.unseenShake]: unseenNotif.length > 0 && Login.is_login,
  });

  return (
    <div style={{ overflow: "visible" }}>
      <div
        className={iconContainerClasses}
        style={{ zIndex: 1000, backgroundColor: "#fff" }}
      >
        <Popover
          placement={popoverPlacement}
          content={popoverContent}
          open={popoverOpen}
          onOpenChange={popoverOnOpenChange}
          trigger="click"
          style={{ cursor: "pointer" }}
          align={{ offset: popoverAlignOffset }}
          onClick={() => navigate("/notifications")}
        >
          <NotificationIcon className={styles.CarIcon} />
        </Popover>
      </div>
    </div>
  );
};
